import { Mail, MapPin, Phone, Clock } from 'lucide-react';
import { company, navLinks, services } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-[#0e1f1c] text-stone-300 mt-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5">
            <div className="h-10 w-10 rounded-xl bg-[#0b6b5b] flex items-center justify-center text-white font-display font-bold text-base leading-none">
              <span>A</span><span className="text-[#f3c14a]">A</span>
            </div>
            <div>
              <div className="font-display font-semibold text-white text-[17px]">
                {company.name}
              </div>
              <div className="text-[11px] tracking-wider uppercase text-stone-400">
                {company.region}
              </div>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-stone-400">
            Friendly, affordable accounting for small business, farms and property
            investors across New Zealand.
          </p>
        </div>

        <div>
          <h4 className="font-display text-white text-base mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="hover:text-[#f3c14a] transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-white text-base mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {services.map((s) => (
              <li key={s.id}>
                <a href="#services" className="hover:text-[#f3c14a] transition-colors">
                  {s.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-white text-base mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5">
              <MapPin className="h-4 w-4 mt-0.5 text-[#f3c14a]" />
              <span>{company.address}</span>
            </li>
            <li className="flex items-start gap-2.5">
              <Phone className="h-4 w-4 mt-0.5 text-[#f3c14a]" />
              <a href={`tel:${company.phone.replace(/\s/g, '')}`} className="hover:text-white">
                {company.phone}
              </a>
            </li>
            <li className="flex items-start gap-2.5">
              <Mail className="h-4 w-4 mt-0.5 text-[#f3c14a]" />
              <a href={`mailto:${company.email}`} className="hover:text-white">
                {company.email}
              </a>
            </li>
            <li className="flex items-start gap-2.5">
              <Clock className="h-4 w-4 mt-0.5 text-[#f3c14a]" />
              <span>Mon–Fri 8:30am – 5:00pm</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-stone-400">
          <p>© {new Date().getFullYear()} {company.name}. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="/privacy" className="hover:text-white transition-colors">Privacy</a>
            <span className="opacity-30">|</span>
            <a href="/terms" className="hover:text-white transition-colors">Terms</a>
            <span className="opacity-30">|</span>
            <span>Proudly NZ owned</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
